<template>
  <div class="app-container post-list">
    <div class="post-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="post-list-filter-value" v-model.trim="search.keywords" @keyup.enter.native="searchChange" placeholder="内容标题/内容正文" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="post-list-filter-value" v-model.trim="search.postedByName" @keyup.enter.native="searchChange" placeholder="发布者昵称或姓名" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="post-list-filter-value" placeholder="所属圈子" v-model="search.circleId" clearable filterable size="small">
              <el-option
                v-for="item in search.circleOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-date-picker
              class="post-list-filter-date"
              v-model="search.searchTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small">
            </el-date-picker>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="post-list-filter-value" placeholder="内容类别" v-model="search.postType" clearable size="small">
              <el-option
                v-for="item in postTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="post-list-filter-value" placeholder="是否官方号发布" v-model="search.isAdminPost" clearable size="small">
              <el-option
                v-for="item in adminPostOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="post-list-filter-value" placeholder="是否已下架" v-model="search.isBannedPost" clearable size="small">
              <el-option
                v-for="item in bannedPostOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="post-list-filter-value" v-model.trim="search.banComment" @keyup.enter.native="searchChange"
             placeholder="下架原因" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6"></el-col>
        <el-col :span="6"></el-col>
        <el-col :span="6"></el-col>
        <el-col :span="6">
          <div>
            <el-button class="post-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="post-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <basic-container class = "post-list-container">
      <avue-crud ref="crud"
        :option="postTableOption"
        :data="tableData"
        :page="page"
        :table-loading="tableLoading"
        :before-open="handleOpenBefore"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        @sort-change="handleSortChange">

        <template slot="title" slot-scope="scope">
          <div class="title">
            <div class="post-cover-image" v-if="!scope.row.isVideoPost && scope.row.coverImg" v-viewer>
              <img v-for="(src, index) in scope.row.attachments" :key="index" :src="src.attachmentUrl" :class="{'hide-redundant-post-images': index > 0 }">
            </div>
            <div class="post-cover-image" v-if="scope.row.isVideoPost && scope.row.coverImg">
              <img :src="scope.row.coverImg" @click="viewVideo(scope.row.attachments[0].attachmentUrl)">
            </div>
            <a href="javascript:void(0);" @click="handleView(scope.row,scope.index);"
                class="post-list-container-button">
              {{scope.row.title}}
            </a>
          </div>
        </template>
        <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.content_list_add">新增内容</el-button>
          <el-button class="filter-item"
                    @click="handleExport()"
                    size="small"
                    type="primary"
                    :loading="exportLoading"
                    icon="el-icon-download">{{exportName}}
          </el-button>
        </template>
        <template slot="menu" slot-scope="scope" width=100>
          <el-button size="mini"
            v-if="permissions.circle_post_edit && scope.row.canEdit"
            type="text"
            icon="icon-edit"
            title="编辑"
            @click="handlePostUpdate(scope.row,scope.index)">
          </el-button>
          <el-button size="mini"
            type="text"
            icon="icon-upload-shelf"
            title="上架"
            v-if="permissions.circle_post_up && scope.row.isBanned"
            @click="handleUp(scope.row,scope.index)">
          </el-button>
          <el-button size="mini"
            type="text"
            icon="icon-download-shelf"
            title="下架"
            v-if="permissions.circle_post_down && !scope.row.isBanned"
            @click="handleDown(scope.row,scope.index)">
          </el-button>
          <el-button type="text"
            v-if="permissions.circle_post_delete && scope.row.canEdit"
            icon="icon-delete"
            size="mini"
            title="删除"
            @click="handleDelete(scope.row,scope.index)"></el-button>
          <el-button type="text"
            icon="icon-hot"
            size="mini"
            title="编辑初始热度值"
            v-if="permissions.circle_post_edit_heat"
            @click="openManualDialog(scope.row)"></el-button>
          <el-button
            title="复制链接"
            size="mini"
            type="text"
            icon="el-icon-share"
            style="font-size: 20px;"
            @click="copyLink(scope.row)"></el-button>
        </template>

      </avue-crud>
    </basic-container>
    <el-dialog title="初始热度值" :visible.sync="manualDialogVisible" width="30%">
      <template>
        <div>
          <label class="manual-input-label">初始热度值</label>
          <el-input-number
            v-model="manualValue"
            :step="1"
            :precision="2"
            :min="0"
            @change="checkManualValue()">
          </el-input-number>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="manualDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateManual()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="下架"
      :visible.sync="banDialogVisible"
      width="30%">
      <template>
        <div>
          <el-label class="down-dialog-item-label">下架原因</el-label>
          <el-input v-model="banDialogComment"></el-input>
        </div>
        <div>
          <el-checkbox class="down-dialog-item-label" v-model="banDialogIsSendWx">是否发送消息通知</el-checkbox>
          <el-input type="textarea" :rows="3" v-if="banDialogIsSendWx" v-model="banDialogSendWxMessage" placeholder="消息"></el-input>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="banDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleDownSubmit()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible="videoPlayDialogVisible" width="40%" class="handle-dialog" @close="closeVideo">
      <video-player
        class="vjs-mc-skin"
        :playsinline="true"
        :options="playerOption"
        ref="videoPlayer">
      </video-player>
    </el-dialog>
  </div>
</template>

<script>
  import {fetchPostList, updatePostBanStatus, removePost, updateManualHeatValue, exportCirclePost} from '@/api/post/post'
  import {getCircleNames} from '@/api/post/circle'
  import {listTableOption} from '@/const/crud/circle/postList'
  import {mapGetters} from "vuex";
  import { exporting } from '@/util/exportUtil'
  
  export default {
    name: "circle_post",
    data() {
      return {
        adminPostOptions: [
          { label: '是', value: 1 },
          { label: '否', value: 0 },
        ],
        postTypeOptions: [
          { label: '图文', value: 0 },
          { label: '视频', value: 1 },
        ],
        bannedPostOptions: [
          { label: '是', value: 1 },
          { label: '否', value: 0 },
        ],
        exportName: "导出",
        exportLoading: false,
        videoPlayDialogVisible: false,
        playerOption: {
          height: '380',
          autoplay: false,
          muted: false,
          loop: false,
          language: 'zh-CN',
          playbackRates: [1.0, 1.5, 2.0],
          notSupportedMessage: '此视频暂无法播放，请稍后再试',
          sources: [],
        },
        search: {
          current: 1,
          size: 10,
          postedByName: "",
          searchTime: [],
          sortField: "",
          sortPolicy: "",
          expired: "",
          postType: "",
          keywords: "",
          circleId: '',
          banComment: "",
          circleOptions: [],
          isAdminPost: "",
          isBannedPost: "",
        },

        // 列表页面
        tableData:[],
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 10, // 每页显示多少条,
        },
        tableLoading: false,
        postTableOption: listTableOption,
        manualDialogVisible: false,
        manualValue : 0,
        banDialogVisible: false,
        banDialogComment: "",
        banDialogIsSendWx: false,
        banDialogSendWxMessage: "",
        banDialogRow: 0,
      };
    },
    async created() {
      await this.getCircleDropOptionse();
      this.queryPosts();
    },
    activated() {
      this.searchChange()
    },
    computed: {
      ...mapGetters(['permissions']),
      startTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 0) {
          return this.search.searchTime[0]
        } else {
          return null
        }
      },
      endTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 1) {
          return this.search.searchTime[1]
        } else {
          return null
        }
      }
    },
    methods: {
      formatData(records) {
        // 帖子列表格式化
        let _this = this
        if (records && records.length > 0) {
          records.forEach(function(record, index) {
            if (record.postedBy) {
              record.postedByName = record.postedBy.name
              record.postedByRealname = record.postedBy.realname
              const isOfficial = record.postedBy.memberType == 1;
              record.canEdit = isOfficial;
              if (record.postedByName == "") {
                record.postedByName = "--"
              }
              if (record.postedByRealname == "") {
                record.postedByRealname = "--"
              }
              if (isOfficial) {
                record.postedByRealname = record.postedBy.relatedPersonalRealname;
              }
            }
            if(!record.title) {
              record.title = "--"
            }
            if (!record.commentCount) {
              record.commentCount = 0
            }
            if (!record.favoriteCount) {
              record.favoriteCount = 0
            }
            if (!record.likeCount) {
              record.likeCount = 0
            }
            if (!record.viewedCount) {
              record.viewedCount = 0
            }

            if (!record.finalHeatValue) {
              record.finalHeatValue = 0;
            }
            if (!record.manualHeatValue) {
              record.manualHeatValue = 0;
            }
            if (!record.banComment){
              record.banComment = "--"
            }
            record.isNotBanned = record.isBanned ? '是' : '否';
            record.isVideoPost = record.postType === 1;
            record.postType = record.postType == 0 ? '图文' : '视频';
          })
        }
        return records
      },
      getParameter(param){
        // 提取url参数值
        let url = location.href
        let reg = new RegExp("(^|&)" + param + "=([^&]*)(&|$)")
        let r = url.substr(url.indexOf("\?") + 1).match(reg)
        if (r != null) return unescape(r[2])
        else return null
      },
      getParams() {
        // 获取帖子列表
        let params = {
          current: this.search.current,
          size: this.search.size,
          // 是否公有
          isGlobal: false
        }
        // 增加搜索功能
        if (this.search.keywords != "" && this.search.keywords.trim() != "")
          params.keywords = this.search.keywords
        if (this.search.postedByName != "" && this.search.postedByName.trim() != "")
          params.postedByName = this.search.postedByName
        if (this.search.circleId != "" && this.search.circleId != null)
          params.circleId = this.search.circleId
        if (this.search.postType !== null && this.search.postType !== "")
          params.postType = this.search.postType
        if (this.search.isAdminPost !== null && this.search.isAdminPost !== "")
          params.memberType = this.search.isAdminPost ? 1 : 0;
        if (this.search.isBannedPost !== null && this.search.isBannedPost !== "")
          params.isBanned = this.search.isBannedPost;

        if (this.startTime && this.endTime) {
          params.postStartTime = this.startTime
          let t = new Date(this.endTime)
          t.setDate(t.getDate() + 1)
          params.postEndTime = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
        } else {
          params.postStartTime = null
          params.postEndTime = null
        }
        if (this.search.banComment != "" && this.search.banComment.trim() != "")
          params.banComment = this.search.banComment

        // 增加排序功能
        if (this.search.sortField != "" && this.search.sortField.trim() != "")
          params.sortField = this.search.sortField
        else
          params.sortField = "post_time"
        if (this.search.sortPolicy != "" && this.search.sortPolicy.trim() != "")
          params.sortPolicy = this.search.sortPolicy
        else
          params.sortPolicy = "desc"
        return params
      },
      getList() {
        let params = this.getParams()
        this.tableLoading = true
        fetchPostList(params).then(response => {
          this.tableData = this.formatData(response.data.data.records)
          this.page.total = response.data.data.total
          this.tableLoading = false
        })
      },
      initPage() {
        this.page.currentPage = 1
        this.page.pageSize = this.search.size
        this.search.current = 1
      },
      // 获取圈子下拉列表
      async getCircleDropOptionse() {
        const response = await getCircleNames();
        if (Array.isArray(response.data.data)) {
          const circleNames = response.data.data.map(x => {
            return {
              value: x.id,
              label: x.circleName
            }
          });
          this.search.circleOptions = this.search.circleOptions.concat(circleNames);
        }
      },
      searchChange() {
        this.initPage()
        this.getList()
      },
      searchReset() {
        this.search.keywords = "";
        this.search.searchTime = []
        this.search.isAdminPost = ""
        this.search.postedByName = "";
        this.search.circleId = "";
        this.search.postType = "";
        this.search.banComment= "";
        this.search.isBannedPost = "";
        this.searchChange()
      },
      handleCurrentChange(val) {
        this.page.currentPage = val
        this.search.current = val
        this.getList()
      },
      handleSizeChange(val) {
        this.page.pageSize = val
        this.search.size = val
        this.getList()
      },
      handleSortChange(val) {
        // 检查排序对象
        if (val.prop == "commentCount") {
          this.search.sortField = "comment_count"
        } else if (val.prop == "favoriteCount") {
          this.search.sortField = "favorite_count"
        } else if (val.prop == "likeCount") {
          this.search.sortField = "like_count"
        } else if (val.prop == "viewedCount") {
          this.search.sortField = "viewed_count"
        } else if (val.prop == "postTime"){
          this.search.sortField = "post_time"
        } else if (val.prop == "finalHeatValue"){
          this.search.sortField = "final_heat_value"
        } else if (val.prop == "manualHeatValue"){
          this.search.sortField = "manual_heat_value"
        } else {
          this.search.sortField = ""
        }
        // 检查排序方式
        if (val.order == 'ascending') {
          this.search.sortPolicy = "asc"
        } else if (val.order == 'descending') {
          this.search.sortPolicy = "desc"
        } else {
          this.search.sortPolicy = ""
        }
        this.getList()
      },
      handleView(row, index) {
        if (row.id){
          this.$router.push({
            path: `/content/list/detail/${row.id}`
          })
        } else {
          this.$message({
            showClose: true,
            message: '该帖子不存在',
            type: 'warning'
          })
        }
      },
      getPostDTO(row, inputIsBanned){
        let postDTO= {
          id: row.id,
          isBanned: inputIsBanned,
        }
        return postDTO
      },
      handleUp(row, index) {
        // 上架功能
        let postDTO = this.getPostDTO(row, 0)
        let _this = this
        this.$confirm('是否确认上架该标题为"' + row.title + '"'+ '的帖子?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          return updatePostBanStatus(postDTO);
        }).then(() => {
          this.getList()
          _this.$message({
            showClose: true,
            message: '上架成功',
            type: 'success'
          })
        }).catch(function () {
        })
      },
      handleDown(row, index) {
        this.banDialogRow = row;
        this.banDialogComment = "";
        this.banDialogIsSendWx = false;
        this.banDialogSendWxMessage = "你发布的图片或视频未能通过系统审核，请重新审核发布内容";
        this.banDialogVisible = true;
      },
      handleDownSubmit() {
        if (!this.banDialogComment) {
          this.$message({
            showClose: true,
            message: '下架原因不能为空',
            type: 'error'
          });
          return;
        }

        if (this.banDialogIsSendWx && !this.banDialogSendWxMessage) {
          this.$message({
            showClose: true,
            message: '发送消息不能为空',
            type: 'error'
          });
          return;
        }

        let postDTO = this.getPostDTO(this.banDialogRow, 1);
        postDTO.banComment = this.banDialogComment;
        postDTO.isSendWxMessage = this.banDialogIsSendWx;
        postDTO.wxMessage = this.banDialogSendWxMessage;
        updatePostBanStatus(postDTO)
          .then(response => {
            this.getList();
            this.$message({
              showClose: true,
              type: 'success',
              message: '下架成功'
            });
          })
          .catch(function () {})
          .finally(() => {
            this.banDialogVisible = false;
          });
      },
      handleOpenBefore(show, type) {
        show();
      },
      handleAdd() {
        this.$router.push({path: '/post/circle/post/add'})
      },
      openManualDialog(row) {
        this.manualDialogVisible = true
        this.manualValue = row.manualHeatValue
        this.postId = row.id
      },
      copyLink(row) {
        let url = process.env.VUE_APP_BASIC_PAGE_PATH + `/post/${row.id}`
        if (row.isVideoPost) {
          url = process.env.VUE_APP_BASIC_PAGE_PATH + `/share/video/${row.id}`
        }
        this.$copyText(url).then(
          res => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '已成功复制'
            })
          },
          err => {
            this.$message({
              showClose: true,
              type: 'error',
              message: '失败'
            })
          }
        )
      },
      updateManual() {
        let params = {
          id: '',
          manual: '',
        }
        params.id = this.postId
        params.manual = this.manualValue
        if (this.manualValue > 99999999) {
          this.$message({
            showClose: true,
            message: '初始值范围为0-99999999',
            type: 'error'
          })
          return
        }
        updateManualHeatValue(params).then((res) => {
          if (res.data.data) {
            this.manualDialogVisible = false
            this.getList()
          }
        })
      },
      checkManualValue() {
        if (this.manualValue > 99999999) {
          this.$message({
            showClose: true,
            message: '初始值范围为0-99999999',
            type: 'error'
          })
        }
      },
      handleDelete(row) {
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          removePost(row.id).then(response => {
            if (response.data.data) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getList()
            }
          }).catch(error => {
            this.$message({
              message: '删除失败',
              type: 'error'
            })
          })
        })
      },
      handlePostUpdate(row) {
        this.$router.push({path: '/post/circle/post/edit', query: {id: row.id}})
      },
      queryPosts() {
        if (this.$route.query.date !== undefined) {
          this.search.searchTime.push(this.$route.query.date, this.$route.query.date)
        }
        this.getList()
      },
      viewVideo(src) {
        if (this.playerOption.sources.length === 0) {
          this.playerOption.sources[0] = { src }
        } else {
          this.$refs.videoPlayer.player.src(src);
        }
        this.videoPlayDialogVisible = true;
      },
      closeVideo() {
        this.$refs.videoPlayer.player.pause();
        this.videoPlayDialogVisible = false;
      },
      handleExport() {
        let params = this.getParams()
        exportCirclePost(params).then(response => {
          if (response.status === 200 && response.data && response.data.data) {
            this.exportLoading = true
            this.exportName = "导出中..."
            exporting(response.data.data, this.exportCallback)
          } else {
            this.$message({
              message: '信息导出失败',
              type: 'warning',
              showClose: true,
            });
          }
        });
      },
      exportCallback(result) {
        this.exportLoading = false
        this.exportName = "导出"
        if (result) {
          this.$message({
            showClose: true,
            message: '导出完成',
            type: 'success'
            })
        }
      },
    }
  };

</script>


<style lang="scss" scoped>

.post-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: 96% !important;
    }
    &-date {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
}
/deep/.el-dialog__body {
  padding : 10px 20px 10px 20px;
}
/deep/.el-input-number {
  line-height: 36px;
}

.title {
  display: flex;
  align-items: center;
  .post-cover-image {
    display: flex;
    width: fit-content;
    margin-right: 12px;
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      max-width: 100%;
    }
  }
}

.post-top-dialog {
  height: 90px;
  &-item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    &-label {
      font-size: 15px;
      color: #606266;
      padding: 10px;
    }
    &-content {
      width: 200px !important;
    }
    &-tip {
      font-size: 12px;
      color: #999999;
      margin-bottom: 10px;
      margin-top: 6px;
    }
    &-value {
      width: 200px;
    }
  }
}
.manual-input-label{
    font-size: 15px;
    color: #606266;
    padding: 10px;
}
.hide-redundant-post-images {
  display: none;
}
.down-dialog-item-label {
  display: inline-block;
  margin: 10px 0;
}
</style>
